/* Aurora stock re-check after a failed add. Opt-in: <product-form data-aur-stock="<handle>">.
   On cart:error, products/<handle>.js (visitor market) decides: variant missing, unavailable
   or 404 -> sold-out state (card "+" removed + badge; else Sold out, wallet hidden).
   Section forms (PDP, set, discovery) check inline. */
(() => {
'use strict';

const doc = document;
const S = (window.themeVariables && window.themeVariables.strings) || {};
const pending = new WeakSet(); // forms with a check in flight
const QUICK_ADD = 'product-card__quick-add-button';

const productUrl = (handle) => {
  const routes = window.Shopify && window.Shopify.routes;
  return `${(routes && routes.root) || '/'}products/${encodeURIComponent(handle)}.js`;
};

// Deepest element holding text, skipping sr-only copies.
const textLeaf = (el, depth) => {
  let best = null;
  Array.from(el.children).forEach((c) => {
    if (c.classList.contains('sr-only')) return;
    const hit = c.children.length ? textLeaf(c, depth + 1) : (c.textContent.trim() ? { el: c, depth } : null);
    if (hit && (!best || hit.depth > best.depth)) best = hit;
  });
  return best;
};

// Prestige badge markup (snippets/product-badges.liquid).
const addBadge = (card) => {
  const fig = card && card.querySelector('.product-card__figure');
  if (!fig || !S.auroraSoldOut || fig.querySelector('.badge--sold-out')) return;
  let list = fig.querySelector('badge-list');
  if (!list) {
    list = doc.createElement('badge-list');
    list.className = 'badge-list badge-list--vertical';
    fig.prepend(list);
  }
  const badge = doc.createElement('sold-out-badge');
  badge.className = 'badge badge--sold-out';
  badge.textContent = S.auroraSoldOut;
  list.prepend(badge);
};

const soldOut = (form, host, buttons) => {
  // Prestige renders no "+" on a sold-out card; the image badge says why.
  if (buttons.some((b) => b.classList.contains(QUICK_ADD))) {
    host.hidden = true;
    addBadge(host.closest('product-card'));
    return;
  }
  buttons.forEach((b) => {
    b.disabled = true;
    const leaf = textLeaf(b, 0);
    if (S.auroraSoldOut) (leaf ? leaf.el : b).textContent = S.auroraSoldOut;
  });
  form.querySelectorAll('.shopify-payment-button').forEach((el) => { el.style.display = 'none'; });
};

doc.addEventListener('cart:error', (e) => {
  const form = e.target;
  if (!form || form.tagName !== 'FORM' || pending.has(form)) return;
  const host = form.closest('[data-aur-stock]');
  const handle = host && host.getAttribute('data-aur-stock');
  const input = handle && form.querySelector('[name="id"]');
  if (!input) return;
  const buttons = Array.from(form.elements).filter((el) => el.type === 'submit'); // form= buttons too
  // Busy, not disabled: theme.js ignores a busy submitter; the look stays.
  const busy = (on) => buttons.forEach((b) => { if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy'); });
  pending.add(form);
  busy(true);
  fetch(productUrl(handle), { credentials: 'same-origin', cache: 'no-store' })
    .then((r) => {
      if (r.ok) return r.json();
      if (r.status === 404) return { variants: [] }; // not sold in this market
      throw new Error(r.status);
    })
    .then((p) => {
      const v = ((p && p.variants) || []).find((x) => String(x.id) === String(input.value));
      if (!(v && v.available)) soldOut(form, host, buttons);
    })
    .catch(() => {}) // offline, 5xx: unchanged
    .then(() => { busy(false); pending.delete(form); });
});
})();
